<template>
    <div>
        <div class="d-flex align-items-center justify-content-center">
            <b-img :src="image + '?cacheblock=yes'" crossorigin="anonymous" v-if="image" class="pr-1"/>
            <p class="mb-0 mt-1">{{name}}</p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CertificateCompetence",
        props:{
            name: String,
            image: String
        }
    }
</script>

<style scoped lang="scss">
    img{
        width: 2rem;
    }
</style>